import temperatureChart from './temperature-chart'
import { probeTempLabel } from '../../../util/probe-label';
import humidityChart from './humidity-chart'

class ReadingCharts {

  constructor (container) {
    this.container = container;
    this.charts = [];

    this.init();
  }

  init() {
    const chartTypes = [
      {
        name: probeTempLabel(),
        datapoint: "tcTemp",
        type: "temperature",
      },
      {
        name: "Temp",
        datapoint: "temperature",
        type: "temperature",
      },
      {
        name: "Humidity",
        datapoint: "humidity",
        type: "humidity",
      },
    ];

    let html = "";

    html += `<div class="reading-charts-tabs">`;

    for(let type of chartTypes) {
      html += `<button class="reading-charts-tab" data-for="${type.datapoint}">${type.name}</button>`;
    }

    html += '</div>';

    for(let type of chartTypes) {

      html += `
      <div class="dashboard-lite__chart" data-for="${type.datapoint}">
        <canvas class="${type.datapoint}-chart" data-for="${type.datapoint}"></canvas>
        <div class="dashboard-lite__chart__no-readings" data-for="${type.datapoint}">
          No readings found for this date range
        </div>
      </div>
      `
    }

    this.container.innerHTML = html;

    for(let type of chartTypes) {

      let chartDiv = this.container.querySelector(`.dashboard-lite__chart[data-for="${type.datapoint}"]`)
      let canvas = this.container.querySelector(`canvas[data-for="${type.datapoint}"]`)
      let noReadingsContainer = this.container.querySelector(`.dashboard-lite__chart__no-readings[data-for="${type.datapoint}"]`)

      let chart = null;

      switch (type.type) {
        case("temperature"):
          chart = new temperatureChart(canvas, {
            source: type.datapoint,
          });
          break;
        case("humidity"):
          chart = new humidityChart(canvas, {
            source: type.datapoint,
          });
          break;
      }

      this.charts.push({
        name: type.name,
        type: type.type,
        datapoint: type.datapoint,
        container: chartDiv,
        chart,
        chartCanvas: canvas,
        noReadingsContainer: noReadingsContainer,
      });

    }

  }

  render(sensor) {

  }

}

export default ReadingCharts;
